import styles from "./index.module.scss";
import Button from "../../../common/button";
import { useDispatch, useSelector } from "react-redux";
import { showPopup } from "/redux/action-creaters/popup";
import { popupTypes } from "/redux/reducers/popupReducer";

export default function LandingsOfferMobile() {
  const { product } = useSelector((state) => state.product);
  const dispatch = useDispatch();
  const quantity = product.CATALOG.QUANTITY;
  const isAlailable = product.CATALOG.AVAILABLE;
  const price = product.CATALOG.MIN_PRICE;
  const noDiscoutPrice = product.CATALOG.PRICE;
  const edostMinPriceCorrected = 0;
  const priceWithCity = price + edostMinPriceCorrected;

  return (
    <div className={styles.Block}>
      <div className={styles.Top}>
        <div>
          {isAlailable && noDiscoutPrice > price && (
            <div className={styles.BeforeValue}>{noDiscoutPrice} руб.</div>
          )}
          <div className={styles.Value}>
            {isAlailable && (
              <>
                <span itemProp="price">{priceWithCity} руб.</span>
              </>
            )}
          </div>
        </div>

        {quantity > 0 ? (
          <span className={styles.InStock}>В наличии: {quantity} шт</span>
        ) : (
          <span className={styles.OutOfStock}>Нет в наличии</span>
        )}
      </div>
      <div className={styles.Bottom}>
        {isAlailable ? (
          <>
            <link itemProp="availability" href="http://schema.org/InStock" />
            <div className={styles.Buttons}>
              <Button
                onClick={async () => {
                  window.open(
                    `https://farkop.ru${product.DETAIL_PAGE_URL}`,
                    "_blank",
                  );
                }}
                label={"Купить"}
              />
            </div>
            <div className={styles.InfoCart}>
              Покупка производится на сайте партнера farkop.ru
            </div>
          </>
        ) : (
          <>
            <Button
              type="outline"
              label={"Оформление предзаказа"}
              onClick={() => {
                dispatch(
                  showPopup(popupTypes.subscribeProduct, {
                    name: `${product.NAME} (арт ${product.ARTICLE?.VALUE}) (id ${product.ID})`,
                    // eslint-disable-next-line no-undef
                    id: productId,
                  }),
                );
              }}
            />
          </>
        )}
      </div>
    </div>
  );
}
